//All the endpoints goes here.
export default {
  filters: "/api/v1/rank-prediction/filters",
  exams: "/api/v1/rank-prediction/exams",
  sponsored_forms: "/api/v1/rank-prediction/sponsored-forms",
  rank: "/api/v1/rank-prediction/rank"
};
